import script from "./DragDropManager.vue?vue&type=script&setup=true&lang=js"
export * from "./DragDropManager.vue?vue&type=script&setup=true&lang=js"

import "./DragDropManager.vue?vue&type=style&index=0&id=442e8bc9&lang=css"

const __exports__ = script;

export default __exports__